import { IGrpRoutesConfig } from "../../../shared/interfaces/IGrpConfig";
import { GovPlanDashboard } from "./dashboard/page";
import { SecretaryProjectDetail } from "./projects/[id]/page";
import { SecretaryProjects } from "./projects/page";

const pages: IGrpRoutesConfig[] = [
    {
        key: "gov-plan-dashboard",
        path: "plano-de-governo",
        element: GovPlanDashboard,
    },
    {
        key: "gov-plan-dashboard",
        path: "plano-de-governo/secretaria/:secretaryId",
        element: SecretaryProjects,
    },
    {
        key: "gov-plan-dashboard",
        path: "plano-de-governo/secretaria/:secretaryId/projetos/:projectId",
        element: SecretaryProjectDetail,
    },
];

export default pages;
